import { Box,Text } from '@chakra-ui/react';
import React from 'react';

function Footer(props) {
    return (
        <Box textAlign={'center'} backgroundColor={'csudark'} padding={5}>
            <Text textColor={'cpdark'}>
            © 2023 SUHAIL K. All rights reserved
            </Text>
        </Box>
    );
}

export default Footer;